import { ref, watch } from "vue";
import { getHooks } from './useHOC'

type DependencyList = ReadonlyArray<unknown>;
const useEffectType = 3

export function useEffect<T>(factory: () => T, deps: DependencyList | undefined) {
  const [hooks, currentHookIndex] = getHooks(useEffectType);
  const hook = hooks?.[currentHookIndex] || ref(deps);
  if (!hooks?.[currentHookIndex]) {
    watch(hook, factory, { immediate: true })
  }
  hooks![currentHookIndex] = hook;
  let changed = false
  deps?.forEach((dep, index) => {
    if (dep !== hook.value[index]) {
      changed = true
    }
  })
  if (changed) {
    hooks![currentHookIndex] = ref(deps);
    watch(hooks![currentHookIndex], factory, { immediate: true })
  }
}